import { Locale } from "@omni/types/enums/locale.enum";

import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $LocalesModuleName } from "./locales.types";

const getLanguages = (state: IState) =>
    getValueState(state, $LocalesModuleName)?.languages || [];

const getCurrentLocale = (state: IState) =>
    getValueState(state, $LocalesModuleName)?.current || Locale.nlBE;

export { getCurrentLocale, getLanguages };
